module.exports = __webpack_public_path__ + "img/table1-bg.df6e2ec9.svg";